
















































































import {
  Vue, Prop, PropSync, Component, Watch,
} from 'vue-property-decorator';
import { PartnersApi } from '@compassdigital/foodworks.ts.sdk';
import { cloneDeep } from 'lodash';
import { mixins } from 'vue-class-component';
import Textfield from '@/components/Form/Textfield/index.vue';
import FoodworksMarket from '@/components/Form/Partner/FoodworksMarket/index.vue';
import EditConfirmation from '@/components/Form/EditConfirmation/index.vue';
import { IMarketInfo } from '@/interface/marketInfo';
import PartnerUtil from '@/util/PartnerUtil';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import PartnerModule from '@/store/modules/partner';
import PermissionMixin from '../../../../../mixins/PermissionMixin';

@Component({
  components: {
    Textfield,
    FoodworksMarket,
    EditConfirmation,
  },
})
export default class FoodworksMarketEdit extends mixins(PermissionMixin) {
  @PropSync('marketInfo', {}) marketInfoSync!: IMarketInfo;

  @Prop({}) markets!: any;

  @Prop({}) scouts!: any;

  get isPartner() {
    return UserModule.currentRole === 'partner_owner';
  }

  public editMode: boolean = false;

  public saving: boolean = false;

  public marketInfoLocal!: IMarketInfo;

  @Watch('marketInfo', { immediate: true })
  onMarketInfoChanged(val: IMarketInfo) {
    if (this.editMode) return;
    this.marketInfoLocal = cloneDeep(val);
  }

  public onEdit() {
    this.marketInfoLocal = cloneDeep(this.marketInfoSync);
    this.editMode = true;
  }

  public onCancel() {
    this.marketInfoSync = cloneDeep(this.marketInfoLocal);
    this.editMode = false;
  }

  public async onSave() {
    if ((this.$refs.form as any).validate()) {
      this.saving = true;
      try {
        const adminData: any = {
          type: this.marketInfoSync.partnerType,
        };
        const api = new PartnersApi(AppModule.apiConfig);
        if (this.marketInfoLocal.partnerType !== this.marketInfoSync.partnerType) {
          await api.patchPartnerById(
            this.marketInfoSync.partnerID!,
            adminData,
          );
        }

        if (this.marketInfoLocal.market !== this.marketInfoSync.market) {
          const adminMarket: any = {
            marketId: this.marketInfoSync.market!,
          };
          await api.patchPartnerById(
            this.marketInfoSync.partnerID!,
            adminMarket,
          );
        }

        if (this.marketInfoLocal.scoutID !== this.marketInfoSync.scoutID) {
          const adminScout: any = {
            scoutUserId: this.marketInfoSync.scoutID!,
          };
          await api.patchPartnerById(
            this.marketInfoSync.partnerID!,
            adminScout!,
          );
        }
        const partner = await api.getPartnerById(this.marketInfoSync.partnerID!);
        PartnerModule.SET_ACTIVE_PARTNER(partner.data);
        const data = PartnerUtil.getMappedPartner(partner.data, this.markets!, this.scouts);
        if (data) {
          this.marketInfoSync = cloneDeep(data.admin!);
          this.marketInfoLocal = cloneDeep(data.admin!);
        }
        this.editMode = false;
      } catch {
        // console.log(err);
      }
      this.saving = false;
    }
  }
}
